module.exports = __webpack_public_path__ + "static/media/XLH_Block.cd85f734.jpg";